module.exports = __webpack_public_path__ + "static/media/APP01@m.529a0e19.jpg";